import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { useAuth } from "@/contexts/auth"
import { StringHelper } from "@/utils"
export const getReceivableInstallments = async (
  params: ScheduleSearchingParamsType
) => {
  const newParams = {
    date: params.date,
    page: params.page,
    quantity: params.quantity,
    status_installment: params.status_installment,
  }
  const queryString =
    StringHelper.objectToQueryString(newParams)
  const url = `${ENDPOINTS.RECEIVABLE_INSTALLMENTS}?${queryString}`
  const { data } =
    await api.get<ReceivablesInstallmentsResponseType>(url)
  return data
}
const useReceivableInstallments = (
  params: ScheduleSearchingParamsType
) => {
  const { authData } = useAuth()
  const isAuthenticated = !!authData?.accessToken
  return useQuery({
    queryKey: [ENDPOINTS.RECEIVABLE_INSTALLMENTS, params],
    queryFn: () => getReceivableInstallments(params),
    enabled: isAuthenticated,
  })
}
export default useReceivableInstallments
